// DS: CO0.1M
import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Sticky from '@wix/da-ds/pkg/Sticky';
import MobileSubmissionDetailsHeader from '../../../SubmissionDetails/MobileSubmissionDetailsHeader';
import SiteHeader from '../../../SiteHeader';
import { useDuperbrowseViewType } from '../../../Duperbrowse/DuperbrowseViewContext';
const DeviationPageHeader = ()=>{
    const isMobile = useContext(MobileContext);
    const { isInDuperbrowse } = useDuperbrowseViewType();
    if (!isMobile) {
        return /*#__PURE__*/ React.createElement(SiteHeader, null);
    }
    if (isInDuperbrowse) {
        return /*#__PURE__*/ React.createElement(Sticky, {
            marginTop: -1
        }, (isStuck)=>/*#__PURE__*/ React.createElement(MobileSubmissionDetailsHeader, {
                isSticky: true,
                isStuck: isStuck
            }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SiteHeader, null), /*#__PURE__*/ React.createElement(MobileSubmissionDetailsHeader, {
        isSticky: false
    }));
};
DeviationPageHeader.displayName = 'DeviationPageHeader';
export default DeviationPageHeader;
